<template>
  <div id="page">
    <v-main>
      <v-container>
        <h2
          style="text-align: center; border-style: solid; border-radius: 50px"
        >
          CleverReach Analyse vorbereiten
        </h2>
        <br />
        <div>
          <span>
            <h3>
              Hier können Sie alle notwendigen Eingaben vornehmen, um mit den
              gewünschten Eckdaten, wie Verkehrsmitteln, Adressen von Reisenden
              (Mitarbeitern, Kunden, Besuchern), einem Reiseziel (Standort) und
              zu berücksichtigenden Parametern (z.B. Zeitaufschlägen, Kosten,
              CO₂ Vorgaben) Analysen und Vergleiche der Strecken und
              Verkehrsmittel vornehmen zu können.
            </h3>
          </span>
          <span
            ><h3>
              Falls noch nicht geschehen, starten Sie am besten mit dem
              Geocoding. Dabei werden entweder bekannten Adressen der Reisenden
              Geo-Koordinaten zugeordnet oder, bei vorhandenen Koordinaten,
              Adressen zugeordnet.
            </h3>
          </span>
        </div>
      </v-container>
      <v-container
        :style="`height: 20px; width: 600px; margin-top:10px; margin-bottom:30px; text-align:center;`"
        v-if="prepare_geocoding_or_import == false"
      >
        <v-row>
          <v-col>
            <v-btn
              v-auth-click="{
                roles: authStore.isLicenceManager || authStore.isSimpleUser,
                message:
                  'Sie haben keine Berechtigung, Geocoding durchzuführen!',
              }"
              class="project-button"
              color="success"
              @click="
                prepare_geocoding = true;
                prepare_geocoding_or_import = true;
              "
              rounded="xl"
              size="x-large"
              elevation="10"
              variant="tonal"
              block
              ><v-icon class="mr-3" icon="mdi-map-marker"></v-icon> Geocoding
              vorbereiten</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <br />
      <br />
      <v-container v-if="prepare_geocoding_or_import == false">
        <v-divider :thickness="2"></v-divider>
      </v-container>
      <v-container
        :style="`height: 20px; width: 600px; margin-top:10px; margin-bottom:30px; text-align:center;`"
        v-if="prepare_geocoding_or_import == false"
      >
        <v-row>
          <v-col>
            <v-btn
              v-auth-click="{
                roles: authStore.isLicenceManager || authStore.isSimpleUser,
                message:
                  'Sie haben keine Berechtigung, Verkehrsmittel auszuwählen!',
              }"
              class="project-button"
              color="success"
              @click="
                prepare_transport_selection = true;
                prepare_geocoding_or_import = true;
              "
              rounded="xl"
              size="x-large"
              elevation="10"
              variant="tonal"
              block
              ><v-icon class="mr-3" icon="mdi-bicycle"></v-icon> Verkehrsmittel
              auswählen</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <br />
      <br />
      <v-container v-if="prepare_geocoding_or_import == false">
        <v-divider :thickness="2"></v-divider>
      </v-container>
      <v-container
        :style="`height: 20px; width: 600px; margin-top:10px; margin-bottom:30px; text-align:center;`"
        v-if="prepare_geocoding_or_import == false"
      >
        <v-row>
          <v-col>
            <v-btn
              v-auth-click="{
                roles: authStore.isLicenceManager || authStore.isSimpleUser,
                message: 'Sie haben keine Berechtigung, Parameter zu setzen!',
              }"
              class="project-button"
              color="success"
              @click="
                showParameters = true;
                prepare_geocoding_or_import = true;
              "
              rounded="xl"
              size="x-large"
              elevation="10"
              variant="tonal"
              block
              ><v-icon class="mr-3" icon="mdi-cogs"></v-icon> Parameter
              setzen</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <br />
      <br />
      <v-container v-if="prepare_geocoding_or_import == false">
        <v-divider :thickness="2"></v-divider>
      </v-container>
      <v-container
        :style="`height: 20px; width: 600px; margin-top:10px; margin-bottom:30px; text-align:center;`"
        v-if="prepare_geocoding_or_import == false"
      >
        <v-col>
          <v-row>
            <v-btn
              v-auth-click="{
                roles: authStore.isLicenceManager || authStore.isSimpleUser,
                message:
                  'Sie haben keine Berechtigung, Gewichtungswerte zu setzen!',
              }"
              class="project-button"
              color="success"
              @click="
                showMobscores = true;
                prepare_geocoding_or_import = true;
              "
              rounded="xl"
              size="x-large"
              elevation="10"
              variant="tonal"
              block
              ><v-icon class="mr-3" icon="mdi-scale-unbalanced"></v-icon>
              Gewichtungswerte setzen</v-btn
            >
          </v-row>
        </v-col>
      </v-container>
      <br />
      <br />
      <v-container v-if="prepare_geocoding_or_import == false">
        <v-divider :thickness="2"></v-divider>
      </v-container>
      <v-container
        :style="`height: 20px; width: 600px; margin-top:10px; margin-bottom:30px; text-align:center;`"
        v-if="prepare_geocoding_or_import == false"
      >
        <v-row>
          <v-col>
            <v-btn
              v-auth-click="{
                roles: authStore.isLicenceManager || authStore.isSimpleUser,
                message:
                  'Sie haben keine Berechtigung, einen CleverRoute Import vorzubereiten!',
              }"
              class="project-button"
              color="success"
              @click="
                prepare_import = true;
                prepare_geocoding_or_import = true;
                showClick();
              "
              rounded="xl"
              size="x-large"
              elevation="10"
              variant="tonal"
              block
              ><v-icon class="mr-3" icon="mdi-import"></v-icon> CleverRoute
              Import vorbereiten</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <br />
      <br />
      <v-row>
        <v-col class="text-left ml-3 d-flex gap-3">
          <v-btn
            @click="reset"
            class="project-button"
            color="error"
            rounded="xl"
            size="large"
            elevation="10"
            variant="tonal"
          >
            <v-icon icon="mdi-refresh"></v-icon>Reset
          </v-btn>
          <v-btn
            :disabled="!prepare_geocoding_or_import"
            @click="handleBackClick"
            class="project-button"
            rounded="xl"
            size="large"
            elevation="10"
            variant="tonal"
          >
            <v-icon class="mr-1" icon="mdi-keyboard-return"></v-icon>Zurück
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn
            :disabled="!prepare_geocoding_or_import || prepare_import"
            @click="handleWeiterClick"
            class="mr-3 project-button"
            rounded="xl"
            size="large"
            elevation="10"
            variant="tonal"
          >
            <v-icon class="mr-1" icon="mdi-keyboard-tab"></v-icon>Weiter
          </v-btn>
        </v-col>
      </v-row>
      <v-container
        v-if="
          prepare_geocoding &&
          (authStore.isLicenceManager || authStore.isSimpleUser)
        "
        class="elevation-4"
        :style="`height: 530px; width: 800px; margin-top:10px;`"
      >
        <v-container>
          <v-form
            ref="form"
            @submit.prevent=""
            validate-on="input"
            v-model:model-value="valid"
          >
            <v-row justify="space-between">
              <v-col :style="`z-index: auto;`">
                <h3>Strecken-Auswahl für Geocoding</h3>
                <v-select
                  label="Projekt"
                  :items="projects"
                  item-title="name"
                  item-value="id"
                  v-model="selectedProjectId"
                ></v-select>
                <v-select
                  label="Firma"
                  :items="companies"
                  :item-title="'name'"
                  :item-value="'id'"
                  v-model="selectedCompanyId"
                ></v-select>
                <v-select
                  label="Standort"
                  :items="offices"
                  :item-title="'office_name'"
                  :item-value="'office_id'"
                  v-model="selectedOfficeId"
                ></v-select>
                <v-row>
                  <v-col class="text-left">
                    <v-btn
                      :disabled="!selectedOfficeId"
                      color="primary"
                      @click="displayGeoPaths"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                      >1. <v-icon icon="mdi-keyboard-return"></v-icon>
                      Strecken einlesen
                    </v-btn>
                  </v-col>
                  <v-col
                    class="text-right"
                    v-if="pathsWithoutGeoData.length > 0"
                  >
                    <v-btn
                      :disabled="!pathsDisplayed"
                      @click="handleGeocodingClick"
                      :loading="loading"
                      color="primary"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                      >2. <v-icon icon="mdi-map-marker"></v-icon>
                      {{ pathsWithoutGeoData.length }} Strecken geocodieren
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
          <v-container>
            <v-row>
              <v-col class="text-center">
                <p>{{ statusMessage }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-progress-circular
                  v-if="
                    loading &&
                    statusMessage ===
                      'Geocoding läuft...(bei größeren Datenmengen kann es mehrere Minuten dauern!)'
                  "
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  :disabled="geocodingDone"
                  @click="tearDownRoutine"
                  rounded="xl"
                  size="large"
                  elevation="10"
                  variant="tonal"
                  margin="10px"
                  >Abbrechen</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-container>
      <v-container
        v-if="
          prepare_transport_selection &&
          (authStore.isLicenceManager || authStore.isSimpleUser)
        "
        class="elevation-4"
        :style="`height: 300px; width: 800px; margin-top:10px;`"
      >
        <h3>Verkehrsmittel Auswahl</h3>
        <v-container>
          <v-form
            ref="form"
            @submit.prevent=""
            validate-on="input"
            v-model:model-value="valid"
          >
            <v-col>
              <v-row>
                <v-select
                  label="Verkehrsmittel"
                  :items="transportItems"
                  item-title="value"
                  item-value="key"
                  chips
                  v-model="selectedTransports"
                  multiple
                ></v-select>
              </v-row> </v-col
          ></v-form>
        </v-container>
      </v-container>
      <v-container
        v-if="
          showParameters &&
          (authStore.isLicenceManager || authStore.isSimpleUser)
        "
      >
        <fade-transition :open="showParameters">
          <div v-if="selectedOfficeId">
            <parameters-table
              :selected-transports="selectedTransports"
              :office-id="selectedOfficeId"
              @parameters-saved="handleParametersSaved"
              @hide-form.native="showParameters = false"
              @cancel-action.native="handleParametersCancel"
            ></parameters-table>

            <!-- Stauaufschläge je PLZ. Steht bewusst neben den übrigen
                 Parametern: fachlich ist es derselbe Zeitaufschlag, nur mit
                 der Herkunfts-PLZ als zusätzlichem Schlüssel. Überschrift und
                 Hintergrundfläche liegen in der Komponente selbst, damit der
                 Abschnitt dieselbe weiße Fläche bekommt wie die
                 Parametertabellen darüber. -->
            <the-plz-surcharges
              :office-id="selectedOfficeId"
            ></the-plz-surcharges>
          </div>

          <!-- Warning if no office selected -->
          <v-alert v-else type="warning" class="ma-4" prominent>
            <v-row align="center">
              <v-col class="grow">
                Bitte wählen Sie zuerst einen Standort aus, bevor Sie Parameter
                setzen.
              </v-col>
            </v-row>
          </v-alert>
        </fade-transition>
      </v-container>
      <v-container
        v-if="
          showMobscores &&
          (authStore.isLicenceManager || authStore.isSimpleUser)
        "
        class="elevation-4"
        :style="`height: 590px; width: 800px; margin-top:10px;`"
      >
        <h3>Gewichtungswerte für Mobscore-Berechnung setzen</h3>
        <v-form ref="mobscoreForm" v-model="mobscoreValid">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" class="mx-auto">
                <v-row v-for="metric in mobscoreMetrics" :key="metric.name">
                  <v-col cols="12">
                    <v-text-field
                      v-model="metric.value"
                      :label="metric.name"
                      type="number"
                      min="0"
                      max="100"
                      suffix="%"
                      :rules="[
                        (v) => !!v || 'Wert erforderlich',
                        (v) =>
                          (v >= 0 && v <= 100) ||
                          'Wert muss zwischen 0 und 100 liegen',
                      ]"
                      @input="validateTotalPercentage"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <div :class="{ 'red--text': totalPercentage !== 100 }">
                      Summe: {{ totalPercentage }} %
                      {{
                        totalPercentage !== 100 ? "(muss 100 % ergeben)" : ""
                      }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                      :disabled="!mobscoreValid"
                      @click="saveMobscoreSettings"
                      color="primary"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                    >
                      Speichern
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-container>
      <v-container
        v-if="
          prepare_import &&
          (authStore.isLicenceManager || authStore.isSimpleUser)
        "
        class="elevation-4 cr-import-container"
      >
        <h3>CleverRoute - Import</h3>
        <v-container class="cr-import-main">
          <v-form
            ref="form"
            @submit.prevent=""
            validate-on="input"
            v-model:model-value="valid"
          >
            <v-row justify="space-between">
              <v-col :style="`z-index: auto;`">
                <h3>1. Strecken-Auswahl</h3>
                <v-select
                  label="Projekt"
                  :items="projects"
                  item-title="name"
                  item-value="id"
                  v-model="selectedProjectId"
                ></v-select>
                <v-select
                  label="Firma"
                  :items="companies"
                  :item-title="'name'"
                  :item-value="'id'"
                  v-model="selectedCompanyId"
                ></v-select>
                <v-select
                  label="Standort"
                  :items="offices"
                  :item-title="'office_name'"
                  :item-value="'office_id'"
                  v-model="selectedOfficeId"
                ></v-select>
                <v-row>
                  <v-col class="text-left">
                    <v-btn
                      :disabled="!selectedOfficeId || loading"
                      color="primary"
                      @click="displayPaths"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                    >
                      <v-icon icon="mdi-check-all"></v-icon>
                      Strecken prüfen
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <h3>2. Transport-Auswahl</h3>
                <p>(Vorauswahl kann im Dropdown geändert werden)</p>
                <v-select
                  label="Verkehrsmittel"
                  :items="transportItems"
                  item-title="value"
                  item-value="key"
                  chips
                  v-model="selectedTransports"
                  multiple
                ></v-select>
                <v-col class="text-right">
                  <!-- Import quota: show the user's remaining budget before starting -->
                  <v-row v-if="quotaStore.quota">
                    <v-col class="text-left">
                      <div class="text-caption">
                        Abfrage-Kontingent: heute noch
                        <strong>{{ quotaStore.quota.dailyRemaining }}</strong> /
                        {{ quotaStore.quota.dailyLimit }}, diesen Monat noch
                        <strong>{{ quotaStore.quota.monthlyRemaining }}</strong> /
                        {{ quotaStore.quota.monthlyLimit }} Abfragen verfügbar.
                      </div>
                      <div
                        v-if="routesChecked && selectedTransports.length > 0"
                        class="text-caption"
                      >
                        Dieser Import benötigt geschätzt
                        <strong>{{ plannedQueries }}</strong> Abfragen
                        ({{ cleverRouteImportStore.number_of_paths }} Adressen ×
                        {{ selectedTransports.length }} Verkehrsmittel).
                      </div>
                      <v-alert
                        v-if="quotaWouldBeExceeded"
                        type="warning"
                        density="compact"
                        variant="tonal"
                        class="mt-1"
                      >
                        Das Kontingent reicht für diesen Import nicht aus. Bitte die
                        Anzahl der Verkehrsmittel reduzieren oder das Kontingent erhöhen
                        lassen.
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-btn
                      :disabled="!routesChecked || loading || quotaWouldBeExceeded"
                      @click="handleImportClick"
                      :loading="loading"
                      color="primary"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                      ><v-icon icon="mdi-import"></v-icon>Import starten</v-btn
                    >
                  </v-row>
                  <!-- make a space between the two buttons -->
                  <v-row><br /></v-row>
                  <v-row>
                    <v-btn
                      :disabled="countDown > 0"
                      @click="createExportDownload"
                      :loading="loadingExport"
                      color="success"
                      ><v-icon icon="mdi-download"></v-icon>CR-Export Datei
                      herunterladen</v-btn
                    >
                  </v-row>
                  <v-row><br /></v-row>
                  <v-row>
                    <v-btn
                      :disabled="countDown > 0"
                      @click="fetchRouteErrors"
                      :loading="loadingExport"
                      color="warning"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                      >Routen Fehler/Warnungen abrufen</v-btn
                    >
                  </v-row>
                </v-col>
                <br />
                <v-col>
                  <v-row>
                    <v-btn
                      :disabled="countDown > 0"
                      @click="fetchCrImportResults"
                      :loading="loadingExport"
                      color="success"
                      rounded="xl"
                      size="large"
                      elevation="10"
                      variant="tonal"
                      ><v-icon icon="mdi-play-box"></v-icon>Ergebnis-Tabelle
                      anzeigen</v-btn
                    >
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-container class="cr-import-footer">
          <v-row>
            <p>{{ statusMessage }}</p>
          </v-row>
          <v-row v-if="loading && batchStatus.is_importing">
            <p>
              Batch {{ batchStatus.current_batch }} von
              {{ batchStatus.total_batches }} wird verarbeitet...
            </p>
          </v-row>
          <v-row>
            <div class="progress-container" style="width: 100%">
              <v-progress-linear
                v-if="loading"
                v-model="current_status"
                max="100"
                height="20"
                color="primary"
                rounded
              ></v-progress-linear>
              <div v-if="loading" class="progress-text">
                {{ Math.round(current_status || 0) }} %
              </div>
            </div>
          </v-row>
          <br />
          <v-row>
            <v-col class="text-center">
              <v-btn @click="tearDownRoutine">Abbrechen</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
      <v-container
        v-if="showPaths || showFailedPaths || showCrImportResults || showErrors"
      >
        <v-pagination
          v-model="currentPage"
          :length="
            showCrImportResults
              ? importResultPages
              : showPaths
                ? Math.ceil(dbPaths.length / pageSize)
                : showFailedPaths
                  ? Math.ceil(failedGeoPaths.length / pageSize)
                  : routeErrorsPages
          "
          :total-visible="5"
          class="my-4"
        ></v-pagination>
        <!-- Regular paths table -->
        <table v-if="showPaths || showErrors || showCrImportResults">
          <thead>
            <tr>
              <th
                v-for="column in currentColumns"
                :key="column"
                :style="{ width: currentColumnMapping[column].width }"
                style="font-weight: bold"
              >
                {{ currentColumnMapping[column].text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in currentRows"
              :key="
                showErrors
                  ? row.id
                  : `${row.path_id || row.id || row.MA_ID}_${index}`
              "
            >
              <td v-for="column in currentColumns" :key="`${column}_${index}`">
                {{ formatValue(row[column], column) }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Failed paths table -->
        <table v-if="showFailedPaths">
          <thead>
            <tr>
              <th
                v-for="column in addressColumns"
                :key="column"
                :style="{ width: addressColumnMapping[column].width }"
                style="font-weight: bold"
              >
                {{ addressColumnMapping[column].text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowKey) in failedGeoPaths" :key="rowKey">
              <td v-for="column in addressColumns" :key="column">
                <input v-model="row[column]" />
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!-- Save changes button -->
        <v-row>
          <v-col class="text-center">
            <v-btn v-if="showFailedPaths" @click="saveChanges" color="primary">
              <v-icon icon="mdi-database-marker-outline"></v-icon>Änderungen
              speichern</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <div class="text-center">
        <v-dialog v-model="savingChanges" width="auto">
          <v-card style="border-radius: 15px">
            <v-card-text>
              <v-row>
                <v-col class="text-center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <div>Änderungen werden gespeichert.</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Resume Import Dialog -->
        <v-dialog v-model="showResumeDialog" max-width="600" persistent>
          <v-card>
            <v-card-title class="headline">
              🔄 Import fortsetzen?
            </v-card-title>

            <v-card-text v-if="resumeSessionData">
              <p class="mb-4">Es wurde ein unvollständiger Import gefunden:</p>

              <v-list>
                <v-list-item>
                  <template v-slot:prepend>
                    <span>📊</span>
                  </template>
                  <v-list-item-title>Fortschritt</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ resumeSessionData.progressPercentage }} % abgeschlossen
                    ({{
                      resumeSessionData.completed_batch_ranges?.length || 0
                    }}
                    von {{ resumeSessionData.total_batches }} Batches)
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item>
                  <template v-slot:prepend>
                    <span>📦</span>
                  </template>
                  <v-list-item-title>Verbleibende Batches</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ resumeSessionData.remainingBatches }} von
                    {{ resumeSessionData.total_batches }}
                  </v-list-item-subtitle>
                </v-list-item>

                <v-list-item>
                  <template v-slot:prepend>
                    <span>💾</span>
                  </template>
                  <v-list-item-title>Gespeichert am</v-list-item-title>
                  <v-list-item-subtitle>
                    {{
                      new Date(resumeSessionData.saved_at).toLocaleString(
                        "de-DE",
                      )
                    }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>

              <v-progress-linear
                :value="resumeSessionData.progressPercentage"
                color="primary"
                height="8"
                class="mt-4"
              ></v-progress-linear>
            </v-card-text>

            <v-card-actions>
              <v-btn color="error" variant="text" @click="handleStartFreshImport">
                🆕 Neuer Import
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn color="primary" @click="handleResumeImport">
                🔄 Fortsetzen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ParametersTable from "./TheParameters.vue";
import ThePlzSurcharges from "./ThePlzSurcharges.vue";
import FadeTransition from "./Animations/FadeTransition.vue";
import { mapStores } from "pinia";
import { useMapInputStore } from "../store/mapInputStore";
import { useOfficeStore } from "../store/officeStore";
import { useCleverRouteImportStore } from "../store/cleverRouteImportStore";
import { useQuotaStore } from "../store/quotaStore";
import { Metric } from "../model/metrics";
import { ImportSettingsInput } from "../model/cleverRouteImport";
import { error, log } from "console";
import { useAuthStore } from "../store/authStore";
import { UserProjectRelation } from "@/api";

interface Column {
  text: string;
  width: string;
}

interface ColumnMapping {
  [key: string]: Column;
}

interface addressColumnMapping {
  [key: string]: Column;
}

export default defineComponent({
  components: {
    ParametersTable,
    FadeTransition,
    ThePlzSurcharges,
  },
  data() {
    return {
      hideForm: false,
      mode: {
        geocoding: "post" as string,
        import: "post" as string,
        parameters: "post" as string,
      },
      countDown: 10,
      currentPage: 1,
      pageSize: 10,
      // Resume import dialog state
      showResumeDialog: false,
      resumeSessionData: null,
      resumeImportResolver: null,
      geocodingDone: true,
      bizmobileety: false,
      savingChanges: false,
      showParameters: false,
      showMobscores: false,
      showPaths: false,
      showErrors: false,
      showCrImportResults: false,
      showFailedPaths: false,
      routesChecked: false,
      usedOriginIdsCount: 0,
      intervalId: null as unknown as NodeJS.Timer | number | null,
      transportItems: [
        { key: "car", value: "Pkw" },
        { key: "car_electric", value: "E-Auto" },
        { key: "train", value: "ÖV" },
        { key: "bike", value: "Fahrrad" },
        { key: "eBike", value: "Pedelec" },
        { key: "bike_and_ride", value: "Bike & Ride" },
        { key: "park_and_ride", value: "Park & Ride" },
        { key: "walk", value: "Fußweg" },
        { key: "bikescooter", value: "BikeScooter" },
        { key: "taxi", value: "Taxi" },
        { key: "ride_and_taxi", value: "Taxi & Ride" },
        { key: "park_ride_and_taxi", value: "Taxi & Park & Ride" },
        {
          key: "ride_and_carshare_flinkster",
          value: "Ride & CarShare Flinkster",
        },
        { key: "eScooter", value: "eScooter" },
        { key: "escooter_and_ride_first_last_escooter", value: "eScooter & Ride" },
        { key: "werksbus", value: "Werksbus" },
        { key: "bike_and_werksbus", value: "Bike & Werksbus" },
        { key: "bahnreaktivierung_and_ride", value: "Bahnreaktivierung & Ride" },
        { key: "park_ride_and_bike", value: "Park & Ride & Bike" },
      ],
      checkedFilters: [],
      metrics: [
        {
          name: "CO₂",
          value: "co2",
        },
        {
          name: "Zeit in min.",
          value: "time_in_mins",
        },
        {
          name: "Schritte",
          value: "sport",
        },
        {
          name: "Kosten in €",
          value: "cost",
        },
      ],
      selectedProjectId: null,
      selectedCompanyId: null,
      selectedOfficeId: null,
      selectedTransports: [] as string[],
      metric: undefined as Metric | undefined,
      importSettingsInput: undefined as ImportSettingsInput | undefined,
      rules: {
        transport: [
          (val: string | undefined) => {
            if (!val) {
              return false;
            }
            return true;
          },
        ],
        mertric: [
          (val: string | undefined) => {
            if (!val) {
              return false;
            }
            return true;
          },
        ],
      },
      valid: undefined as boolean | undefined,
      statusMessage: "" as string,
      loading: false,
      downloadReady: false,
      loadingExport: false,
      pathsDisplayed: false,
      prepare_import: false,
      prepare_geocoding: false,
      prepare_geocoding_or_import: false,
      prepare_transport_selection: false,
      addressColumns: [
        "id",
        "street",
        "house_number",
        "postal_code",
        "district",
        "geo",
      ],
      tableColumns: [
        // only showing the columns that are relevant for the user
        // "path_id",
        // "project_id",
        "origin_id",
        "origin_geo",
        "origin_street",
        "origin_postal_code",
        "origin_district",
        // "arrival",
        // "departure",
        // "company_id",
        "destination_id",
        "destination_street",
        "destination_house_number",
        "destination_postal_code",
        "destination_district",
        "destination_geo",
      ],
      errorColumns: [
        "id",
        "timestamp",
        "path_id",
        "transport",
        "error",
        "warning",
      ],
      crExportColumns: [
        "MA_ID",
        "path_id",
        "office_id",
        "Start_Straße",
        "Start_Ortschaft",
        "Start_PLZ",
        "latitude",
        "longitude",
        "PKW_Entfernung",
        "Pedelec_Entfernung",
        "Fahrrad_Entfernung",
        "OeV_Entfernung",
        "OeV_Fahrrad_Entfernung",
        "Auto_OeV_Entfernung",
        "E_Auto_Entfernung",
        "Fuss_Weg_Entfernung",
        "BikeScooter_Entfernung",
        "Taxi_Entfernung",
        "Taxi_OeV_Entfernung",
        "eScooter_Entfernung",
        "eScooter_OeV_Entfernung",
        "Werksbus_Entfernung",
        "Fahrrad_Werksbus_Entfernung",
        "Bahnreakt_Ride_Entfernung",
        "Park_Ride_and_Bike_Entfernung",
        "PKW_Zeit",
        "Pedelec_Zeit",
        "Fahrrad_Zeit",
        "OeV_Zeit",
        "OeV_Fahrrad_Zeit",
        "Auto_OeV_Zeit",
        "E_Auto_Zeit",
        "Fuss_Weg_Zeit",
        "BikeScooter_Zeit",
        "Taxi_Zeit",
        "Taxi_OeV_Zeit",
        "eScooter_Zeit",
        "eScooter_OeV_Zeit",
        "Werksbus_Zeit",
        "Fahrrad_Werksbus_Zeit",
        "Bahnreakt_Ride_Zeit",
        "Park_Ride_and_Bike_Zeit",
        // Stauaufschlag je Herkunfts-PLZ in Minuten, additiv zu den
        // Zeit-Spalten. Leer, solange für den Standort nichts gepflegt ist.
        "PKW_Stau",
        "Pedelec_Stau",
        "Fahrrad_Stau",
        "OeV_Stau",
        "OeV_Fahrrad_Stau",
        "Auto_OeV_Stau",
        "E_Auto_Stau",
        "Fuss_Weg_Stau",
        "BikeScooter_Stau",
        "Taxi_Stau",
        "Taxi_OeV_Stau",
        "eScooter_Stau",
        "eScooter_OeV_Stau",
        "Werksbus_Stau",
        "Fahrrad_Werksbus_Stau",
        "Bahnreakt_Ride_Stau",
        "Park_Ride_and_Bike_Stau",
        "PKW_Kosten",
        "Pedelec_Kosten",
        "Fahrrad_Kosten",
        "OeV_Kosten",
        "OeV_Fahrrad_Kosten",
        "Auto_OeV_Kosten",
        "E_Auto_Kosten",
        "Fuss_Weg_Kosten",
        "BikeScooter_Kosten",
        "Taxi_Kosten",
        "Taxi_OeV_Kosten",
        "eScooter_Kosten",
        "eScooter_OeV_Kosten",
        "Werksbus_Kosten",
        "Fahrrad_Werksbus_Kosten",
        "Bahnreakt_Ride_Kosten",
        "Park_Ride_and_Bike_Kosten",
        "PKW_CO2",
        "Pedelec_CO2",
        "Fahrrad_CO2",
        "OeV_CO2",
        "OeV_Fahrrad_CO2",
        "Auto_OeV_CO2",
        "E_Auto_CO2",
        "Fuss_Weg_CO2",
        "BikeScooter_CO2",
        "Taxi_CO2",
        "Taxi_OeV_CO2",
        "eScooter_CO2",
        "eScooter_OeV_CO2",
        "Werksbus_CO2",
        "Fahrrad_Werksbus_CO2",
        "Bahnreakt_Ride_CO2",
        "Park_Ride_and_Bike_CO2",
        "PKW_Bewegung",
        "Pedelec_Bewegung",
        "Fahrrad_Bewegung",
        "OeV_Bewegung",
        "OeV_Fahrrad_Bewegung",
        "Auto_OeV_Bewegung",
        "E_Auto_Bewegung",
        "Fuss_Weg_Bewegung",
        "BikeScooter_Bewegung",
        "Taxi_Bewegung",
        "Taxi_OeV_Bewegung",
        "eScooter_Bewegung",
        "eScooter_OeV_Bewegung",
        "Werksbus_Bewegung",
        "Fahrrad_Werksbus_Bewegung",
        "Bahnreakt_Ride_Bewegung",
        "Park_Ride_and_Bike_Bewegung",
        "PKW_Mobscore",
        "Pedelec_Mobscore",
        "Fahrrad_Mobscore",
        "OeV_Mobscore",
        "Bike_and_Ride_Mobscore",
        "Park_and_Ride_Mobscore",
        "E_Auto_Mobscore",
        "Fuss_Weg_Mobscore",
        "BikeScooter_Mobscore",
        "Taxi_Mobscore",
        "Taxi_and_Ride_Mobscore",
        "eScooter_Mobscore",
        "eScooter_and_Ride_Mobscore",
        "Werksbus_Mobscore",
        "Fahrrad_Werksbus_Mobscore",
        "Bahnreakt_Ride_Mobscore",
        "Park_Ride_and_Bike_Mobscore",
        "Kosten_effektivstes_VM",
        "Zeit_effektivstes_VM",
        "CO2_effektivstes_VM",
        "Bewegungs_effektivstes_VM",
        "Nutzen_effektivste_VM",
      ],
      mobscoreValid: false,
      mobscoreMetrics: [
        { name: "Kosten", value: 30 },
        { name: "CO₂", value: 20 },
        { name: "Zeit", value: 30 },
        { name: "Bewegung", value: 20 },
      ],
    };
  },
  emits: {
    "set-map-settings": () => {
      return true;
    },
    "cancel-action": () => {
      return true;
    },
  },
  props: {
    // in case the settigns should appear on top of the ui
    zIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    /**
     * settingsType must be a value in [0,1,2]
     * You can use the enum MapSettingType.
     * 0: Standard
     * 1: Metric
     * 2: CompareMetric
     */
    settingsType: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  created() {
    console.log("ImportManager created with:", {
      projectId: this.initialProjectId,
      companyId: this.initialCompanyId,
      officeId: this.initialOfficeId,
    });
  },
  async mounted() {
    await this.setUp();

    // Ensure user data is loaded
    if (this.authStore.authenticated && !this.authStore.userRole) {
      await this.authStore.retrieveUserData();
    }

    if (this.officeStore.selectedProject) {
      this.selectedProjectId = await this.officeStore.selectedProject.id;
    }
    if (this.officeStore.selectedCompany) {
      this.selectedCompanyId = await this.officeStore.selectedCompany.id;
    }
    if (this.officeStore.selectedOffice) {
      this.selectedOfficeId = await this.officeStore.selectedOffice.office_id;
    }
    this.selectedTransports = [
      "car",
      "car_electric",
      "eBike",
      "train",
      "bike_and_ride",
      "park_and_ride",
    ];
  },
  async beforeUnmount() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  },
  computed: {
    ...mapStores(useMapInputStore, useOfficeStore, useCleverRouteImportStore, useQuotaStore),
    /** Estimated number of import queries for the current selection (paths x transports). */
    plannedQueries() {
      return this.cleverRouteImportStore.number_of_paths * this.selectedTransports.length;
    },
    /** True when the estimated import would exceed the remaining daily or monthly quota. */
    quotaWouldBeExceeded() {
      const quota = this.quotaStore.quota;
      if (!quota || this.selectedTransports.length === 0) return false;
      return (
        this.plannedQueries > quota.dailyRemaining ||
        this.plannedQueries > quota.monthlyRemaining
      );
    },
    initialProjectId() {
      return this.officeStore.getSelectedProject?.id || 0;
    },
    initialCompanyId() {
      return this.officeStore.getSelectedCompany?.id || 0;
    },
    initialOfficeId() {
      return this.officeStore.getSelectedOffice?.office_id || 0;
    },
    offices() {
      // @ts-ignore
      return this.officeStore.getOffices;
    },
    companies() {
      // @ts-ignore
      return this.officeStore.getCompanies;
    },
    projects() {
      // @ts-ignore
      return this.officeStore.getProjects;
    },
    selectedProject() {
      // @ts-ignore
      let selected = this.projects.find((val: object) => {
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedProjectId) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
    selectedCompany() {
      // @ts-ignore
      let selected = this.companies.find((val: object) => {
        console.log("Company val: ", val);
        console.log("Company selectedCompanyId: ", this.selectedCompanyId);
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedCompanyId) {
            return true;
          }
        }
        return false;
      });
      // return fallback
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
    selectedOffice() {
      // @ts-ignore
      let selected: object = this.offices.find((val: object) => {
        // @ts-ignore
        if (val["office_id"]) {
          // @ts-ignore
          if (val["office_id"] === this.selectedOfficeId) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return {
          name: null,
          type: null,
          owner: null,
          street: null,
          house_number: null,
          postal_code: null,
          district: null,
          geo: {
            coordinates: [null, null],
          },
        };
      }
      return selected;
    },
    parametersUpdated() {
      // @ts-ignore
      return this.cleverRouteImportStore.parametersUpdated;
    },
    current_status() {
      // @ts-ignore
      return this.cleverRouteImportStore.current_status;
    },
    // Frontend batch processing progress
    batchProgress() {
      // @ts-ignore
      return this.cleverRouteImportStore.getBatchProgress;
    },
    batchStatus() {
      // @ts-ignore
      return this.cleverRouteImportStore.getBatchStatus;
    },
    displayedPaths() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      if (this.failedGeoPaths.length > 0) {
        return this.failedGeoPaths.slice(startIndex, endIndex);
      } else {
        return this.dbPaths.slice(startIndex, endIndex);
      }
    },
    displayedRouteErrors() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.routeErrors.slice(startIndex, endIndex);
    },
    routeErrorsPages() {
      return Math.ceil(this.routeErrors.length / this.pageSize);
    },
    dbPaths() {
      // @ts-ignore
      return this.cleverRouteImportStore.dbPaths;
    },
    failedGeoPaths() {
      // @ts-ignore
      return this.cleverRouteImportStore.failedGeoPaths;
    },
    routeErrors() {
      // @ts-ignore
      return this.cleverRouteImportStore.route_errors;
    },
    crImportResults() {
      // @ts-ignore
      return this.cleverRouteImportStore.cr_import_results;
    },
    displayCrImportResults() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.crImportResults.slice(startIndex, endIndex);
    },
    importResultPages() {
      return Math.ceil(this.crImportResults.length / this.pageSize);
    },
    uniqueAddresses() {
      // @ts-ignore
      return this.cleverRouteImportStore.uniqueAddresses;
    },
    currentColumns() {
      if (this.showPaths && !this.showErrors && !this.showCrImportResults) {
        return this.tableColumns;
      } else if (
        !this.showPaths &&
        this.showErrors &&
        !this.showCrImportResults
      ) {
        return this.errorColumns;
      } else if (
        !this.showPaths &&
        !this.showErrors &&
        this.showCrImportResults
      ) {
        return this.crExportColumns;
      }
      return []; // Add a default return statement
    },
    currentColumnMapping() {
      if (this.showPaths && !this.showErrors && !this.showCrImportResults) {
        return this.pathColumnMapping;
      } else if (
        !this.showPaths &&
        this.showErrors &&
        !this.showCrImportResults
      ) {
        return this.errorColumnMapping;
      } else if (
        !this.showPaths &&
        !this.showErrors &&
        this.showCrImportResults
      ) {
        return this.crExportColumnMapping;
      }
      return []; // Add a default return statement
    },
    currentRows() {
      if (this.showPaths && !this.showErrors && !this.showCrImportResults) {
        return this.displayedPaths;
      } else if (
        !this.showPaths &&
        this.showErrors &&
        !this.showCrImportResults
      ) {
        return this.displayedRouteErrors;
      } else if (
        !this.showPaths &&
        !this.showErrors &&
        this.showCrImportResults
      ) {
        return this.displayCrImportResults;
      }
      return []; // Add a default return statement
    },
    pathColumnMapping(): ColumnMapping {
      return {
        origin_id: { text: "MA Adress ID", width: "100px" },
        origin_geo: { text: "MA Geo", width: "150px" },
        origin_street: { text: "MA Straße", width: "150px" },
        origin_postal_code: { text: "MA PLZ", width: "150px" },
        origin_district: { text: "MA Ort", width: "150px" },
        destination_id: { text: "Standort ID", width: "100px" },
        destination_street: {
          text: "Standort Straße",
          width: "150px",
        },
        destination_house_number: {
          text: "Standort Hausnr",
          width: "200px",
        },
        destination_postal_code: {
          text: "Standort PLZ",
          width: "150px",
        },
        destination_district: { text: "Standort Ort", width: "150px" },
        destination_geo: { text: "Standort Geo", width: "150px" },
      };
    },
    errorColumnMapping(): ColumnMapping {
      return {
        id: { text: "ID", width: "100px" },
        timestamp: { text: "Timestamp", width: "150px" },
        path_id: { text: "Strecken ID", width: "100px" },
        transport: { text: "Verkehrsmittel", width: "150px" },
        error: { text: "Fehler", width: "150px" },
        warning: { text: "Warnung", width: "150px" },
      };
    },
    addressColumnMapping(): addressColumnMapping {
      return {
        id: { text: "MA Adress ID", width: "100px" },
        geo: { text: "MA Geo", width: "150px" },
        street: { text: "MA Straße", width: "150px" },
        house_number: { text: "MA Hausnr", width: "50px" },
        postal_code: { text: "MA PLZ", width: "150px" },
        district: { text: "MA Ort", width: "150px" },
      };
    },
    crExportColumnMapping(): ColumnMapping {
      return {
        MA_ID: { text: "MA ID", width: "150px" },
        path_id: { text: "Strecken ID", width: "150px" },
        office_id: { text: "Standort ID", width: "150px" },
        Start_Straße: { text: "Start Straße", width: "150px" },
        Start_Ortschaft: { text: "Start Ortschaft", width: "150px" },
        Start_PLZ: { text: "Start PLZ", width: "150px" },
        latitude: { text: "Breitengrad", width: "150px" },
        longitude: { text: "Längengrad", width: "150px" },
        PKW_Entfernung: { text: "Pkw Entfernung", width: "150px" },
        Pedelec_Entfernung: { text: "Pedelec Entfernung", width: "150px" },
        Fahrrad_Entfernung: { text: "Fahrrad Entfernung", width: "150px" },
        OeV_Entfernung: { text: "ÖV Entfernung", width: "150px" },
        OeV_Fahrrad_Entfernung: {
          text: "Bike & Ride Entfernung",
          width: "150px",
        },
        Auto_OeV_Entfernung: { text: "Park & Ride Entfernung", width: "150px" },
        E_Auto_Entfernung: { text: "E_Auto Entfernung", width: "150px" },
        Fuss_Weg_Entfernung: { text: "Fussweg Entfernung", width: "150px" },
        BikeScooter_Entfernung: {
          text: "BikeScooter Entfernung",
          width: "150px",
        },
        Taxi_Entfernung: { text: "Taxi Entfernung", width: "150px" },
        Taxi_OeV_Entfernung: { text: "Ride & Taxi Entfernung", width: "150px" },
        eScooter_Entfernung: { text: "eScooter Entfernung", width: "150px" },
        eScooter_OeV_Entfernung: {
          text: "eScooter & Ride Entfernung",
          width: "150px",
        },
        Werksbus_Entfernung: { text: "Werksbus Entfernung", width: "150px" },
        Fahrrad_Werksbus_Entfernung: {
          text: "Bike & Werksbus Entfernung",
          width: "150px",
        },
        Bahnreakt_Ride_Entfernung: {
          text: "Bahnreaktivierung & Ride Entfernung",
          width: "150px",
        },
        Park_Ride_and_Bike_Entfernung: {
          text: "Park & Ride & Bike Entfernung",
          width: "150px",
        },
        PKW_Zeit: { text: "Pkw Zeit", width: "150px" },
        Pedelec_Zeit: { text: "Pedelec Zeit", width: "150px" },
        Fahrrad_Zeit: { text: "Fahrrad Zeit", width: "150px" },
        OeV_Zeit: { text: "ÖV Zeit", width: "150px" },
        OeV_Fahrrad_Zeit: { text: "Bike & Ride Zeit", width: "150px" },
        Auto_OeV_Zeit: { text: "Park & Ride Zeit", width: "150px" },
        E_Auto_Zeit: { text: "E_Auto Zeit", width: "150px" },
        Fuss_Weg_Zeit: { text: "Fussweg Zeit", width: "150px" },
        BikeScooter_Zeit: { text: "BikeScooter Zeit", width: "150px" },
        Taxi_Zeit: { text: "Taxi Zeit", width: "150px" },
        Taxi_OeV_Zeit: { text: "Ride & Taxi Zeit", width: "150px" },
        eScooter_Zeit: { text: "eScooter Zeit", width: "150px" },
        eScooter_OeV_Zeit: { text: "eScooter & Ride Zeit", width: "150px" },
        Werksbus_Zeit: { text: "Werksbus Zeit", width: "150px" },
        Fahrrad_Werksbus_Zeit: {
          text: "Bike & Werksbus Zeit",
          width: "150px",
        },
        Bahnreakt_Ride_Zeit: {
          text: "Bahnreaktivierung & Ride Zeit",
          width: "150px",
        },
        Park_Ride_and_Bike_Zeit: {
          text: "Park & Ride & Bike Zeit",
          width: "150px",
        },
        PKW_Stau: { text: "Pkw Stauaufschlag", width: "150px" },
        Pedelec_Stau: { text: "Pedelec Stauaufschlag", width: "150px" },
        Fahrrad_Stau: { text: "Fahrrad Stauaufschlag", width: "150px" },
        OeV_Stau: { text: "ÖV Stauaufschlag", width: "150px" },
        OeV_Fahrrad_Stau: {
          text: "Bike & Ride Stauaufschlag",
          width: "150px",
        },
        Auto_OeV_Stau: { text: "Park & Ride Stauaufschlag", width: "150px" },
        E_Auto_Stau: { text: "E_Auto Stauaufschlag", width: "150px" },
        Fuss_Weg_Stau: { text: "Fussweg Stauaufschlag", width: "150px" },
        BikeScooter_Stau: { text: "BikeScooter Stauaufschlag", width: "150px" },
        Taxi_Stau: { text: "Taxi Stauaufschlag", width: "150px" },
        Taxi_OeV_Stau: { text: "Ride & Taxi Stauaufschlag", width: "150px" },
        eScooter_Stau: { text: "eScooter Stauaufschlag", width: "150px" },
        eScooter_OeV_Stau: {
          text: "eScooter & Ride Stauaufschlag",
          width: "150px",
        },
        Werksbus_Stau: { text: "Werksbus Stauaufschlag", width: "150px" },
        Fahrrad_Werksbus_Stau: {
          text: "Bike & Werksbus Stauaufschlag",
          width: "150px",
        },
        Bahnreakt_Ride_Stau: {
          text: "Bahnreaktivierung & Ride Stauaufschlag",
          width: "150px",
        },
        Park_Ride_and_Bike_Stau: {
          text: "Park & Ride & Bike Stauaufschlag",
          width: "150px",
        },
        PKW_Kosten: { text: "Pkw Kosten", width: "150px" },
        Pedelec_Kosten: { text: "Pedelec Kosten", width: "150px" },
        Fahrrad_Kosten: { text: "Fahrrad Kosten", width: "150px" },
        OeV_Kosten: { text: "ÖV Kosten", width: "150px" },
        OeV_Fahrrad_Kosten: { text: "Bike & Ride Kosten", width: "150px" },
        Auto_OeV_Kosten: { text: "Park & Ride Kosten", width: "150px" },
        E_Auto_Kosten: { text: "E_Auto Kosten", width: "150px" },
        Fuss_Weg_Kosten: { text: "Fussweg Kosten", width: "150px" },
        BikeScooter_Kosten: { text: "BikeScooter Kosten", width: "150px" },
        Taxi_Kosten: { text: "Taxi Kosten", width: "150px" },
        Taxi_OeV_Kosten: { text: "Ride & Taxi Kosten", width: "150px" },
        eScooter_Kosten: { text: "eScooter Kosten", width: "150px" },
        eScooter_OeV_Kosten: { text: "eScooter & Ride Kosten", width: "150px" },
        Werksbus_Kosten: { text: "Werksbus Kosten", width: "150px" },
        Fahrrad_Werksbus_Kosten: {
          text: "Bike & Werksbus Kosten",
          width: "150px",
        },
        Bahnreakt_Ride_Kosten: {
          text: "Bahnreaktivierung & Ride Kosten",
          width: "150px",
        },
        Park_Ride_and_Bike_Kosten: {
          text: "Park & Ride & Bike Kosten",
          width: "150px",
        },
        PKW_CO2: { text: "Pkw CO₂", width: "150px" },
        Pedelec_CO2: { text: "Pedelec CO₂", width: "150px" },
        Fahrrad_CO2: { text: "Fahrrad CO₂", width: "150px" },
        OeV_CO2: { text: "ÖV CO₂", width: "150px" },
        OeV_Fahrrad_CO2: { text: "Bike & Ride CO₂", width: "150px" },
        Auto_OeV_CO2: { text: "Park & Ride CO₂", width: "150px" },
        E_Auto_CO2: { text: "E_Auto CO₂", width: "150px" },
        Fuss_Weg_CO2: { text: "Fussweg CO₂", width: "150px" },
        BikeScooter_CO2: { text: "BikeScooter CO₂", width: "150px" },
        Taxi_CO2: { text: "Taxi CO₂", width: "150px" },
        Taxi_OeV_CO2: { text: "Ride & Taxo CO₂", width: "150px" },
        eScooter_CO2: { text: "eScooter CO₂", width: "150px" },
        eScooter_OeV_CO2: { text: "eScooter & Ride CO₂", width: "150px" },
        Werksbus_CO2: { text: "Werksbus CO₂", width: "150px" },
        Fahrrad_Werksbus_CO2: {
          text: "Bike & Werksbus CO₂",
          width: "150px",
        },
        Bahnreakt_Ride_CO2: {
          text: "Bahnreaktivierung & Ride CO₂",
          width: "150px",
        },
        Park_Ride_and_Bike_CO2: {
          text: "Park & Ride & Bike CO₂",
          width: "150px",
        },
        PKW_Bewegung: { text: "Pkw Bewegung", width: "150px" },
        Pedelec_Bewegung: { text: "Pedelec Bewegung", width: "150px" },
        Fahrrad_Bewegung: { text: "Fahrrad Bewegung", width: "150px" },
        OeV_Bewegung: { text: "ÖV Bewegung", width: "150px" },
        OeV_Fahrrad_Bewegung: { text: "Bike & Ride Bewegung", width: "150px" },
        Auto_OeV_Bewegung: { text: "Park & Ride Bewegung", width: "150px" },
        E_Auto_Bewegung: { text: "E_Auto Bewegung", width: "150px" },
        Fuss_Weg_Bewegung: { text: "Fussweg Bewegung", width: "150px" },
        BikeScooter_Bewegung: { text: "BikeScooter Bewegung", width: "150px" },
        Taxi_Bewegung: { text: "Taxi Bewegung", width: "150px" },
        Taxi_OeV_Bewegung: { text: "Ride & Taxi Bewegung", width: "150px" },
        eScooter_Bewegung: { text: "eScooter Bewegung", width: "150px" },
        eScooter_OeV_Bewegung: {
          text: "eScooter & Ride Bewegung",
          width: "150px",
        },
        Werksbus_Bewegung: { text: "Werksbus Bewegung", width: "150px" },
        Fahrrad_Werksbus_Bewegung: {
          text: "Bike & Werksbus Bewegung",
          width: "150px",
        },
        Bahnreakt_Ride_Bewegung: {
          text: "Bahnreaktivierung & Ride Bewegung",
          width: "150px",
        },
        Park_Ride_and_Bike_Bewegung: {
          text: "Park & Ride & Bike Bewegung",
          width: "150px",
        },
        PKW_Mobscore: { text: "Pkw Mobscore", width: "150px" },
        Pedelec_Mobscore: { text: "Pedelec Mobscore", width: "150px" },
        Fahrrad_Mobscore: { text: "Fahrrad Mobscore", width: "150px" },
        OeV_Mobscore: { text: "ÖV Mobscore", width: "150px" },
        Bike_and_Ride_Mobscore: {
          text: "Bike & Ride Mobscore",
          width: "150px",
        },
        Park_and_Ride_Mobscore: {
          text: "Park & Ride Mobscore",
          width: "150px",
        },
        E_Auto_Mobscore: { text: "E_Auto Mobscore", width: "150px" },
        Fuss_Weg_Mobscore: { text: "Fussweg Mobscore", width: "150px" },
        BikeScooter_Mobscore: { text: "BikeScooter Mobscore", width: "150px" },
        Taxi_Mobscore: { text: "Taxi Mobscore", width: "150px" },
        Taxi_and_Ride_Mobscore: {
          text: "Ride & Taxi Mobscore",
          width: "150px",
        },
        eScooter_Mobscore: { text: "eScooter Mobscore", width: "150px" },
        eScooter_and_Ride_Mobscore: {
          text: "eScooter & Ride Mobscore",
          width: "150px",
        },
        Werksbus_Mobscore: { text: "Werksbus Mobscore", width: "150px" },
        Fahrrad_Werksbus_Mobscore: {
          text: "Bike & Werksbus Mobscore",
          width: "150px",
        },
        Bahnreakt_Ride_Mobscore: {
          text: "Bahnreaktivierung & Ride Mobscore",
          width: "150px",
        },
        Park_Ride_and_Bike_Mobscore: {
          text: "Park & Ride & Bike Mobscore",
          width: "150px",
        },
        Kosten_effektivstes_VM: {
          text: "Kosten effektivstes VM",
          width: "150px",
        },
        Zeit_effektivstes_VM: { text: "Zeit effektivstes VM", width: "150px" },
        CO2_effektivstes_VM: { text: "CO₂ effektivstes VM", width: "150px" },
        Bewegungs_effektivstes_VM: {
          text: "Bewegungs effektivstes VM",
          width: "150px",
        },
        Nutzen_effektivste_VM: {
          text: "Nutzen effektivstes VM",
          width: "150px",
        },
      };
    },
    totalPercentage() {
      return this.mobscoreMetrics.reduce(
        (sum, metric) => sum + Number(metric.value || 0),
        0,
      );
    },
    pathsWithoutGeoData() {
      return this.dbPaths.filter((path) => {
        const originMissing =
          !path.origin_geo ||
          !path.origin_geo.coordinates ||
          path.origin_geo.coordinates.length === 0 ||
          (path.origin_geo.coordinates[0] === null &&
            path.origin_geo.coordinates[1] === null);

        const destinationMissing =
          !path.destination_geo ||
          !path.destination_geo.coordinates ||
          path.destination_geo.coordinates.length === 0 ||
          (path.destination_geo.coordinates[0] === null &&
            path.destination_geo.coordinates[1] === null);

        return originMissing || destinationMissing;
      });
    },
    pathsWithGeoData() {
      return this.dbPaths.filter((path) => {
        const originHasGeo =
          path.origin_geo &&
          path.origin_geo.coordinates &&
          path.origin_geo.coordinates.length > 0 &&
          path.origin_geo.coordinates[0] !== null &&
          path.origin_geo.coordinates[1] !== null;

        const destinationHasGeo =
          path.destination_geo &&
          path.destination_geo.coordinates &&
          path.destination_geo.coordinates.length > 0 &&
          path.destination_geo.coordinates[0] !== null &&
          path.destination_geo.coordinates[1] !== null;

        return originHasGeo && destinationHasGeo;
      });
    },
    totalPaths() {
      return this.dbPaths.length;
    },
  },
  methods: {
    async setUp() {
      // this.officeStore.$reset();
      this.selectedProjectId = null;
      this.selectedCompanyId = null;
      this.selectedOfficeId = null;
      // this.selectedTransports = [];
      // this.secondTransport = undefined;
      // this.metric = undefined;
      this.prepare_import = false;
      this.prepare_geocoding_or_import = false;
      await this.officeStore.fetchProjects();
    },
    // ***** Geocoding *****
    async handleGeocodingClick() {
      try {
        await this.startGeocodingDestination();
        await this.startGeocoding();
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    async startGeocodingDestination() {
      try {
        const address_id =
          await this.cleverRouteImportStore.getDestinationAddressId(
            this.selectedOfficeId,
          );
        const destinationGeo = this.officeStore.getSelectedOffice?.geo;

        if (
          !destinationGeo ||
          !destinationGeo.coordinates ||
          destinationGeo.coordinates.length === 0 ||
          (destinationGeo.coordinates[0] === null &&
            destinationGeo.coordinates[1] === null)
        ) {
          await this.cleverRouteImportStore.geocodeDestination(address_id);
        }
      } catch (error) {
        console.error("Error in startGeocodingDestination:", error);
      }
    },

    async startGeocoding() {
      console.log("Starte Geocoding");
      this.loading = true;
      this.statusMessage = "Geocoding läuft...";
      this.geocodingDone = false;

      try {
        const usedAdressIds = new Set();
        const failedGeocoding = [];
        let successfulGeocodings = 0;

        // Use either failed paths if they exist, or paths without geo data
        const pathsToProcess =
          this.failedGeoPaths.length > 0
            ? this.failedGeoPaths
            : this.pathsWithoutGeoData; // Using our improved geo data detection

        console.log("Paths to process: ", pathsToProcess);

        for (const path of pathsToProcess) {
          const adressId = path.origin_id || path.id;
          if (!usedAdressIds.has(adressId)) {
            usedAdressIds.add(adressId);
            const result =
              await this.cleverRouteImportStore.startGeocoding(path);
            if (result.success) {
              successfulGeocodings++;
              // console.log("Successful Geocodings: ", successfulGeocodings);
              this.showFailedPaths = false;
            } else {
              failedGeocoding.push(result);
            }
          }
        }

        this.usedOriginIdsCount = usedAdressIds.size;
        this.statusMessage = "Checking for failed geocoding";

        // Fetch failed geocoding paths from the backend
        await this.cleverRouteImportStore.fetchFailedGeocodingPaths(
          this.selectedProjectId,
          this.selectedCompanyId,
          this.selectedOfficeId,
        );

        // Display failed geocoding paths
        await this.displayFailedGeocodingPaths(failedGeocoding);

        this.loading = false;
        this.geocodingDone = true;
      } catch (error) {
        console.error(error);
        this.statusMessage = "Geocoding failed";
        this.loading = false;
      }
    },

    async displayGeoPaths() {
      try {
        // Clear any previous states
        this.showFailedPaths = false;
        this.failedGeoPaths = [];

        // Fetch paths
        await this.cleverRouteImportStore.fetchPathViews(
          this.selectedProjectId,
          this.selectedCompanyId,
          this.selectedOfficeId,
        );

        // Show paths table
        this.pathsDisplayed = true;
        this.showPaths = true;

        // Update status message
        const totalPaths = this.totalPaths;
        const pathsWithGeo = this.pathsWithGeoData.length;
        const pathsNeedingGeo = this.pathsWithoutGeoData.length;

        this.statusMessage =
          `${pathsWithGeo} von ${totalPaths} Strecken haben bereits Geo-Daten. ` +
          (pathsNeedingGeo > 0
            ? `${pathsNeedingGeo} Strecken benötigen noch Geocoding.`
            : "Alle Strecken sind bereits geocodiert.");
      } catch (error) {
        console.error("Error fetching paths:", error);
        this.statusMessage = "Fehler beim Einlesen der Strecken!";
      }
    },
    async saveChanges() {
      this.savingChanges = true;
      try {
        // Update each failed path individually
        for (const path of this.failedGeoPaths) {
          await this.cleverRouteImportStore.putAdressFailedGeocoding(
            path,
            path.id,
          );
        }
        this.pathsWithoutGeoData = this.failedGeoPaths;
        console.log("Successfully saved changes for failed geocoding paths");
      } catch (error) {
        console.error("Error saving changes:", error);
      } finally {
        this.savingChanges = false;
      }
    },
    async displayFailedGeocodingPaths(failedGeocoding) {
      try {
        console.log("Getting failed geocoding paths");
        const failedPaths = this.cleverRouteImportStore.failedGeoPaths;

        if (failedPaths.length === 0) {
          // If no failed paths, show success message and original paths
          await this.cleverRouteImportStore.fetchPathViews(
            this.selectedProjectId,
            this.selectedCompanyId,
            this.selectedOfficeId,
          );
          this.showFailedPaths = false;
          this.showPaths = true;
          this.statusMessage =
            "Alle Adressen in den Strecken wurden erfolgreich geocodiert!";
        } else {
          // If there are failed paths, show them for correction
          const successfulCount = this.usedOriginIdsCount - failedPaths.length;
          this.statusMessage = `Es wurden ${successfulCount} Adressen erfolgreich geocodiert. ${failedGeocoding.length} sind fehlerhaft. Bitte Adressen korrigieren und erneut versuchen.
          Falls Geo-Daten manuell eingegeben werden sollen, bitte im Format "longitude, latitude" (Bsp.: 50.78334, 7.049) eingeben.`;

          // Hide paths table and show failed paths table
          this.showPaths = false;
          this.showFailedPaths = true;
          this.failedGeoPaths = failedPaths;
        }
        console.log("Failed Geocoding Paths: ", this.failedGeoPaths);
      } catch (error) {
        console.error(error);
      }
    },

    // ***** CR Import *****
    async handleImportClick() {
      try {
        await this.startImport();
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    async startImport() {
      console.log("Starting frontend-driven batch import");
      this.loading = true;
      this.statusMessage = "Import läuft...";

      const importSettings: ImportSettingsInput = {
        projectId: this.selectedProjectId,
        companyId: this.selectedCompanyId,
        officeId: this.selectedOfficeId,
        transports: this.selectedTransports,
      };

      try {
        // Check for existing incomplete import sessions
        let resumeSessionId = null;
        const existingSessions =
          this.cleverRouteImportStore.getIncompleteImportSessions(
            this.selectedProjectId,
            this.selectedCompanyId,
            this.selectedOfficeId,
          );

        if (existingSessions && existingSessions.length > 0) {
          const shouldResume = await this.confirmResumeImport(
            existingSessions[0],
          );
          if (shouldResume) {
            resumeSessionId = existingSessions[0].session_id;
            this.statusMessage = `Import wird fortgesetzt... (${existingSessions[0].progressPercentage} % bereits abgeschlossen)`;
          } else {
            // Clear the old session if user chooses not to resume
            await this.cleverRouteImportStore.clearImportSession(
              existingSessions[0].session_id,
            );
          }
        }

        // Start the frontend-driven batch import (with optional resume)
        await this.cleverRouteImportStore.startBatchImport(
          importSettings,
          resumeSessionId,
        );

        // Import completed successfully
        this.statusMessage = "Import erfolgreich abgeschlossen";
        this.loading = false;
        this.downloadReady = true;
        this.$emit("set-map-settings");

        // Refresh the remaining quota after a successful import
        await this.quotaStore.fetchUserQuota();

        // Start countdown for result availability
        this.finishDataFetchingRoutine();
      } catch (error) {
        if (error instanceof Error && error.message === "IMPORT_ABORTED_BY_USER") {
          this.loading = false;
          if (!this.statusMessage) {
            this.statusMessage = "Import wurde abgebrochen.";
          }
          await this.quotaStore.fetchUserQuota();
          return;
        }
        console.error("Batch import failed:", error);
        // Surface the backend message (e.g. "[FORBIDDEN] Tageskontingent erschöpft ...")
        // instead of a generic, here misleading, "can be resumed later" text.
        const backendMessage =
          error && typeof error === "object" && "message" in error
            ? (error as { message?: string }).message
            : undefined;
        this.statusMessage =
          backendMessage || "Import fehlgeschlagen - kann später fortgesetzt werden";
        this.loading = false;
        // Refresh quota so the displayed remaining budget reflects a possible rejection
        await this.quotaStore.fetchUserQuota();
        this.$emit("set-map-settings");
      }
    },

    /**
     * Confirm with user whether to resume existing import or start fresh
     */
    async confirmResumeImport(existingSession: any): Promise<boolean> {
      return new Promise((resolve) => {
        // Store session data and show dialog
        this.resumeSessionData = existingSession;
        this.showResumeDialog = true;

        // Store resolve function for dialog handlers
        this.resumeImportResolver = resolve;
      });
    },

    /**
     * User chose to resume the existing import
     */
    handleResumeImport() {
      console.log(
        `🔄 User chose to resume import session: ${this.resumeSessionData.session_id}`,
      );
      this.showResumeDialog = false;
      this.resumeImportResolver(true);
    },

    /**
     * User chose to start a fresh import
     */
    handleStartFreshImport() {
      console.log(`🆕 User chose to start fresh import`);
      this.showResumeDialog = false;
      this.resumeImportResolver(false);
    },

    // REMOVED: Status polling methods no longer needed with frontend-driven batching
    // The frontend now calculates progress directly from completed batches

    finishDataFetchingRoutine() {
      this.loading = false;
      // Reduced countdown since processing is now synchronous
      // Results are available immediately after import completion
      this.countDown = 5;
      this.countDownTimer();
      this.$emit("set-map-settings");
    },

    countDownTimer() {
      if (this.countDown > 0) {
        // Changed from > 1 to > 0
        setTimeout(() => {
          this.countDown -= 1;
          if (this.countDown > 0) {
            this.statusMessage = `Ergebnis bereit in ${this.countDown} Sekunden.`;
            this.countDownTimer();
          } else {
            this.statusMessage = "Ergebnis bereit";
          }
        }, 1000);
      }
    },

    async fetchRouteErrors() {
      this.showErrors = true;
      this.showPaths = false;
      try {
        // @ts-ignore
        await this.cleverRouteImportStore.fetchRouteErrors();
      } catch (error) {
        // @ts-ignore
        console.error(error);
      }
    },

    async fetchCrImportResults() {
      this.showCrImportResults = true;
      this.showPaths = false;
      this.showErrors = false;
      try {
        const originIdFirst = this.uniqueAddresses[0].origin_id;
        const originIdLast =
          this.uniqueAddresses[this.uniqueAddresses.length - 1].origin_id;
        // @ts-ignore
        await this.cleverRouteImportStore.fetchCrImportResults(
          originIdFirst,
          originIdLast,
          this.selectedOfficeId,
        );
      } catch (error) {
        // @ts-ignore
        console.error(error);
      }
    },

    async createExportDownload() {
      this.loadingExport = true; // Start loading indicator
      try {
        // @ts-ignore
        const response =
          await this.cleverRouteImportStore.createExportDownload();

        if (response) {
          const url = window.URL.createObjectURL(
            new Blob([response], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "cr_export_final.csv");
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url); // Clean up
          this.loadingExport = false; // Stop loading indicator
        }
      } catch (error) {
        // @ts-ignore
        console.error("Error downloading the file:", error);
      } finally {
        this.loading = false; // Stop loading indicator
      }
    },

    formatValue(value, column) {
      if (column === "origin_geo" || column === "destination_geo") {
        if (value && value.coordinates) {
          return `${value.coordinates[0]}, ${value.coordinates[1]}`;
        } else {
          return "Keine Geo-Koordinaten";
        }
      } else {
        return value;
      }
    },

    async displayPaths() {
      try {
        // @ts-ignore
        await this.cleverRouteImportStore.fetchPathViews(
          // @ts-ignore
          this.selectedProjectId,
          this.selectedCompanyId,
          this.selectedOfficeId,
        );
        this.statusMessage = `Es wurden ${this.dbPaths.length} Strecken mit ${this.uniqueAddresses.length} Mitarbeiteradressen (MA) gefunden.`;
        this.showPaths = true;
        this.pathsDisplayed = true;
        this.routesChecked = true;
        // Load the user's import quota so it can be shown before starting the import
        await this.quotaStore.fetchUserQuota();
      } catch (error) {
        // @ts-ignore
        console.error(error);
      }
    },

    handleWeiterClick() {
      if (this.geocodingDone || this.prepare_geocoding) {
        this.prepare_geocoding = false;
        this.prepare_transport_selection = true;
        this.prepare_geocoding_or_import = true;
        this.pathsDisplayed = false;
        this.geocodingDone = false;
        this.showPaths = false;
      } else if (this.prepare_transport_selection) {
        this.prepare_transport_selection = false;
        this.prepare_geocoding_or_import = true;
        this.showParameters = true;
      } else if (this.showParameters || this.parametersUpdated) {
        this.showParameters = false;
        this.cleverRouteImportStore.parametersUpdated = false; // Reset flag after moving to mobscores
        this.prepare_geocoding_or_import = true;
        this.showMobscores = true;
      } else if (this.showMobscores) {
        this.showMobscores = false;
        this.prepare_geocoding_or_import = true;
        this.prepare_import = true;
        this.showClick();
      }
    },

    handleBackClick() {
      if (this.prepare_geocoding) {
        this.prepare_geocoding = false;
        this.reset();
      } else if (this.prepare_transport_selection) {
        this.prepare_transport_selection = false;
        this.prepare_geocoding_or_import = true;
        this.prepare_geocoding = true;
      } else if (this.showParameters) {
        this.showParameters = false;
        this.prepare_geocoding_or_import = true;
        this.prepare_transport_selection = true;
      } else if (this.showMobscores) {
        this.showMobscores = false;
        this.prepare_geocoding_or_import = true;
        this.showParameters = true;
      } else if (this.prepare_import) {
        this.prepare_import = false;
        this.prepare_geocoding_or_import = true;
        this.showMobscores = true;
      }
    },

    async tearDownRoutine() {
      // This routine will be activated, if the user wants to cancel the geocoding or the import.
      // It will give the user a chance to start over and re-run the routine.
      const importAbortRequested = this.prepare_import && (this.loading || this.cleverRouteImportStore.is_batch_importing);
      const projectIdAtAbort = this.selectedProjectId || undefined;
      const officeIdAtAbort = this.selectedOfficeId || undefined;
      if (importAbortRequested) {
        try {
          const abortResponse = await this.cleverRouteImportStore.abort_import(
            projectIdAtAbort,
            officeIdAtAbort,
          );
          const settlement = abortResponse?.settlement;
          const actualUsed = settlement?.actual_used;
          const reservedAmount = settlement?.reserved_amount;
          const releasedUnused = settlement?.released_unused;

          if (
            typeof actualUsed === "number" &&
            typeof reservedAmount === "number" &&
            typeof releasedUnused === "number"
          ) {
            this.statusMessage =
              `Import abgebrochen. ${actualUsed} von ${reservedAmount} reservierten Abfragen wurden genutzt, ` +
              `${releasedUnused} wurden freigegeben.`;
          } else {
            this.statusMessage = "Import wurde abgebrochen.";
          }
          this.loading = false;
          this.cleverRouteImportStore.is_batch_importing = false;
          this.currentPage = 1;
          await this.quotaStore.fetchUserQuota();
          return;
        } catch (error) {
          this.loading = false;
          this.statusMessage = "Import-Abbruch ausgelöst, aber Rückmeldung vom Backend fehlgeschlagen.";
          return;
        }
      }

      await this.cleverRouteImportStore.abort_import(projectIdAtAbort, officeIdAtAbort);

      this.countDown = 0;
      this.loading = false;
      this.statusMessage = "";
      this.selectedOfficeId = null;
      this.selectedCompanyId = null;
      this.selectedProjectId = null;
      this.firstTransport = undefined;
      this.selectedTransports = [];
      this.metric = undefined;
      this.prepare_import = false;
      this.prepare_geocoding = false;
      this.prepare_geocoding_or_import = false;
      this.geocodingDone = false;
      this.showPaths = false;
      this.showFailedPaths = false;
      this.showCrImportResults = false;
      this.showErrors = false;
      this.checkedFilters = [];
      this.mapInputStore.$reset();
      // this.officeStore.$reset();
      console.log("Tear down routine");
      // No need to stop status polling - we don't use it anymore!
      this.cleverRouteImportStore.$reset();
      this.officeStore.fetchProjects();
      this.$emit("cancel-action");
      this.setUp();
    },
    showClick() {
      console.log("Prepare_Import state: ", this.prepare_import);
    },
    reset() {
      this.countDown = 0;
      this.selectedProjectId = null;
      this.selectedCompanyId = null;
      this.selectedOfficeId = null;
      this.metric = undefined;
      this.importSettingsInput = undefined;
      this.prepare_import = false;
      this.prepare_geocoding = false;
      this.prepare_geocoding_or_import = false;
      this.prepare_transport_selection = false;
      this.geocodingDone = false;
      this.showPaths = false;
      this.showParameters = false;
      this.showFailedPaths = false;
      this.showErrors = false;
      this.showCrImportResults = false;
      this.checkedFilters = [];
      this.mapInputStore.$reset();
      // this.officeStore.$reset();
      this.cleverRouteImportStore.$reset();
      this.officeStore.fetchProjects();
      this.$emit("cancel-action");
      this.hideForm = true;
      this.setUp();
    },
    validateTotalPercentage() {
      this.mobscoreValid = this.totalPercentage === 100;
    },
    async saveMobscoreSettings() {
      console.log("Saving mobscore settings");
      console.log("Selected office-id: ", this.selectedOfficeId);
      if (!this.selectedOfficeId) {
        // Show error message that company must be selected
        console.warn(
          `unable to save mobscore settings, because selected office-id: ${this.selectedOfficeId} is a falsey value`,
        );
        return;
      }

      try {
        await this.cleverRouteImportStore.saveMobscoreSettings(
          this.selectedOfficeId,
          this.mobscoreMetrics,
        );
        // Optionally show success message
        console.log("Mobscore settings saved successfully");
      } catch (error) {
        // Handle error / show error message
        console.error("Error saving mobscore settings:", error);
      }
    },

    // NEW: Parameter handling methods for office-specific parameters

    /**
     * Handle successful parameter save
     */
    handleParametersSaved() {
      this.statusMessage = "Parameter erfolgreich gespeichert!";
      this.cleverRouteImportStore.parametersUpdated = true;

      // Clear message after 3 seconds
      setTimeout(() => {
        this.statusMessage = "";
      }, 3000);
    },

    /**
     * Handle parameter cancel
     */
    handleParametersCancel() {
      this.showParameters = false;
      this.prepare_geocoding_or_import = false;
    },
  },
  watch: {
    async selectedProjectId(newVal, oldVal) {
      // console.log("Selected Project-ID: ", this.selectedProjectId);
      if (newVal != oldVal) {
        this.selectedCompanyId = null;
        this.selectedOfficeId = null;
        await this.officeStore.fetchCompanies(newVal);
      }
    },
    async selectedCompanyId(newVal, oldVal) {
      // console.log("Selected Company-ID: ", this.selectedCompanyId);
      if (newVal != oldVal) {
        this.selectedOfficeId = null;
        if (this.selectedCompanyId) {
          await this.officeStore.fetchOffices(this.selectedProjectId, newVal);
        } else {
          console.warn(
            `unable to fetch offices, because selected company-id: ${this.selectedCompanyId} is a falsey value`,
          );
        }
      }
    },
    async selectedOfficeId(newVal, oldVal) {
      // console.log("Selected Office-ID: ", this.selectedOfficeId);
      if (newVal != oldVal) {
        await this.officeStore.fetchShifts(newVal);
      }
    },
    initialProjectId(newVal) {
      console.log("ImportManager - received projectId:", newVal);
    },
    initialCompanyId(newVal) {
      console.log("ImportManager - received companyId:", newVal);
    },
    initialOfficeId(newVal) {
      console.log("ImportManager - received officeId:", newVal);
    },
  },
  setup() {
    const authStore = useAuthStore();
    return {
      authStore,
    };
  },
});
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  display: block;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

h3 {
  margin-bottom: 10px;
}
.container-style {
  height: 500px;
  width: 400px;
}

ul {
  columns: 2;
  -webkit-columns: 2;
  -moz-columns: 2;
}

ul label {
  padding: 5px;
}

.progress-container {
  position: relative;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  z-index: 1;
  font-size: 12px;
}

.project-button {
  backdrop-filter: blur(2px);
  background-color: rgba(255, 255, 255, 0.85) !important;
}

.cr-import-container {
  min-height: 590px;
  width: 800px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.cr-import-main {
  flex: 1 1 auto;
}

.cr-import-footer {
  margin-top: auto;
}

.v-container.elevation-4 {
  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.9) !important;
}

/* Only apply background to the main content container, not button containers */
.v-main > .v-container:first-child {
  backdrop-filter: blur(2px);
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-radius: 8px;
}

/* Table styling for better readability */
table {
  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.95) !important;
  border-radius: 8px;
  overflow-x: auto;
  overflow-y: hidden;
}

table th {
  background-color: rgba(255, 255, 255, 0.9) !important;
}

table tr:nth-child(even) {
  background-color: rgba(240, 240, 240, 0.9) !important;
}

table tr:nth-child(odd) {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

#page {
  display: flex;
  justify-content: center;
  align-items: self-start;
  min-height: 100vh;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0.65)
    ),
    url(https://demo.cleverroute.net/hero.jpg);
  background-size: cover;
  background-position: left;
  background-attachment: fixed;
  padding-bottom: 50px;
}
</style>
